import React from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { selectEntityNameMap } from 'store/loanApplications/selectors';
import {
  selectOtherUsersInSection,
  selectOtherUsersInSectionWithSubtab,
} from 'store/presence/selectors';

import PresenceDot from './PresenceDot';

const PresenceSectionDot = ({ sectionId, subtab, variant = 'inline' }) => {
  const selector = _.isNil(subtab)
    ? selectOtherUsersInSection(sectionId)
    : selectOtherUsersInSectionWithSubtab(sectionId, subtab);

  const otherUsers = useSelector(selector);

  const entityNameMap = useSelector(selectEntityNameMap);

  return <PresenceDot entityNameMap={entityNameMap} users={otherUsers} variant={variant} />;
};

PresenceSectionDot.propTypes = {
  sectionId: PropTypes.string.isRequired,
  subtab: PropTypes.string,
  variant: PropTypes.oneOf(['absolute', 'inline']),
};

export default PresenceSectionDot;
